function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Empty } from "../../components/analytics-kit";
import { Loader } from "../../components/loaders";
import Error from "../../components/error";
import DataShell, { Btn, Notice, isAdmin } from "./shell";
import { getTiers, putTiers, getQuoteSettings, putQuoteSettings, DEFAULT_SETTINGS, searchDealers, putDealerTier } from "../sales/sales-quotes-api";
import { errText } from "../quotes/common";

/*
 * Manage Data › Price tiers (SALES_QUOTES_ORDER_DESK.md §6, §12 `/quotes/tiers` and `/quotes/settings`;
 * approved mockup Tiers.dc.html, 2026-10-09). Left: "Dealer price levels" cards (percent off list, category
 * overrides in plain words, a worked example, dealer count) with a ··· menu, plus "Give a dealer a different
 * level". Right: "Quote settings". The tier list is one PUT, so every level change (edit, add, make default,
 * delete) saves the whole list right away and only applies locally once the server accepts it.
 */
const EXAMPLE = 2000;
const usd0 = v => `$${Math.round(Number(v) || 0).toLocaleString("en-US")}`;
const pct = v => {
  const x = Number(v);
  return Number.isFinite(x) ? `${Math.round(x * 100) / 100}%` : "0%";
};
const codeFrom = name => String(name || "").toUpperCase().replace(/[^A-Z0-9]+/g, "_").replace(/^_+|_+$/g, "").slice(0, 24);
const FREIGHT = [["quote", "Quoted separately"], ["flat", "A flat amount"], ["tbd", "To be decided later"]];
function overridesText(ov) {
  const e = Object.entries(ov || {});
  return e.map(([cat, p]) => `${pct(p)} off ${cat}`).join(", ");
}
function RowMenu({
  items
}) {
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (!open) return undefined;
    const off = e => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", off);
    return () => document.removeEventListener("mousedown", off);
  }, [open]);
  return /*#__PURE__*/React.createElement("span", {
    className: "dr-menu",
    ref: ref
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dr-more",
    "aria-label": "More actions",
    onClick: () => setOpen(!open)
  }, "\xB7\xB7\xB7"), open ? /*#__PURE__*/React.createElement("span", {
    className: "dr-menu-pop"
  }, items.filter(Boolean).map(it => /*#__PURE__*/React.createElement("button", {
    type: "button",
    key: it.label,
    className: it.danger ? "danger" : "",
    disabled: it.disabled,
    onClick: () => {
      setOpen(false);
      it.onClick();
    }
  }, it.label))) : null);
}

/** Inline editor for one level. `tier` is a copy; onSave gets the edited tier. */
function LevelForm({
  tier,
  isNew,
  busy,
  codesTaken,
  onSave,
  onCancel
}) {
  const [t, setT] = React.useState({
    ...tier,
    categoryOverrides: {
      ...(tier.categoryOverrides || {})
    }
  });
  const [codeTouched, setCodeTouched] = React.useState(!isNew);
  const [ov, setOv] = React.useState({
    cat: "",
    pct: ""
  });
  const [err, setErr] = React.useState(null);
  const set = patch => setT(x => ({
    ...x,
    ...patch
  }));
  const addOv = () => {
    if (!ov.cat.trim() || ov.pct === "") return;
    set({
      categoryOverrides: {
        ...t.categoryOverrides,
        [ov.cat.trim()]: Number(ov.pct) || 0
      }
    });
    setOv({
      cat: "",
      pct: ""
    });
  };
  const save = () => {
    const name = String(t.name || "").trim();
    const code = String(t.code || codeFrom(name)).trim().toUpperCase();
    if (!name) {
      setErr("Give the level a name.");
      return;
    }
    if (!code) {
      setErr("Give the level a short code.");
      return;
    }
    if (codesTaken.indexOf(code) >= 0) {
      setErr(`Another level already uses the code ${code}.`);
      return;
    }
    const d = Number(t.discountPct);
    if (!Number.isFinite(d) || d < 0 || d > 100) {
      setErr("The discount needs to be between 0 and 100%.");
      return;
    }
    setErr(null);
    onSave({
      ...t,
      name,
      code,
      discountPct: d
    });
  };
  const d = Number(t.discountPct) || 0;
  return /*#__PURE__*/React.createElement("div", {
    className: "dr-level dr-level-edit"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dr-form-grid"
  }, /*#__PURE__*/React.createElement("label", {
    className: "dr-field"
  }, "Name", /*#__PURE__*/React.createElement("input", {
    value: t.name,
    autoFocus: isNew,
    placeholder: "For example Gold",
    onChange: e => set({
      name: e.target.value,
      ...(codeTouched ? {} : {
        code: codeFrom(e.target.value)
      })
    })
  })), /*#__PURE__*/React.createElement("label", {
    className: "dr-field"
  }, "Percent off list", /*#__PURE__*/React.createElement("span", {
    className: "dr-suffix"
  }, /*#__PURE__*/React.createElement("input", {
    type: "number",
    min: "0",
    max: "100",
    step: "0.5",
    value: t.discountPct,
    onChange: e => set({
      discountPct: e.target.value
    })
  }), /*#__PURE__*/React.createElement("i", null, "%"))), /*#__PURE__*/React.createElement("label", {
    className: "dr-field"
  }, "Short code", /*#__PURE__*/React.createElement("input", {
    value: t.code,
    spellCheck: false,
    placeholder: "GOLD",
    onChange: e => {
      setCodeTouched(true);
      set({
        code: e.target.value.toUpperCase().replace(/[^A-Z0-9_-]/g, "")
      });
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "dr-help"
  }, "How this level appears in your customer file."))), /*#__PURE__*/React.createElement("div", {
    className: "dr-field"
  }, "Different discount for a product type", Object.keys(t.categoryOverrides).length ? /*#__PURE__*/React.createElement("span", {
    className: "dr-ovs"
  }, Object.entries(t.categoryOverrides).map(([cat, p]) => /*#__PURE__*/React.createElement("span", {
    key: cat,
    className: "dr-ov"
  }, pct(p), " off ", cat, /*#__PURE__*/React.createElement("a", {
    title: "Remove",
    onClick: () => {
      const n = {
        ...t.categoryOverrides
      };
      delete n[cat];
      set({
        categoryOverrides: n
      });
    }
  }, "\xD7")))) : null, /*#__PURE__*/React.createElement("span", {
    className: "dr-ov-add"
  }, /*#__PURE__*/React.createElement("input", {
    placeholder: "Product type",
    value: ov.cat,
    onChange: e => setOv({
      ...ov,
      cat: e.target.value
    })
  }), /*#__PURE__*/React.createElement("span", {
    className: "dr-suffix sm"
  }, /*#__PURE__*/React.createElement("input", {
    type: "number",
    min: "0",
    max: "100",
    placeholder: "0",
    value: ov.pct,
    onChange: e => setOv({
      ...ov,
      pct: e.target.value
    }),
    onKeyDown: e => {
      if (e.key === "Enter") addOv();
    }
  }), /*#__PURE__*/React.createElement("i", null, "%")), /*#__PURE__*/React.createElement(Btn, {
    small: true,
    onClick: addOv,
    disabled: !ov.cat.trim() || ov.pct === ""
  }, "Add"))), /*#__PURE__*/React.createElement("span", {
    className: "dr-example"
  }, "A ", usd0(EXAMPLE), " item quotes at ", usd0(EXAMPLE * (1 - Math.min(100, Math.max(0, d)) / 100)), "."), err ? /*#__PURE__*/React.createElement("span", {
    className: "dr-err"
  }, err) : null, /*#__PURE__*/React.createElement("span", {
    className: "dr-form-btns"
  }, /*#__PURE__*/React.createElement(Btn, {
    small: true,
    onClick: onCancel,
    disabled: busy
  }, "Cancel"), /*#__PURE__*/React.createElement(Btn, {
    small: true,
    primary: true,
    onClick: save,
    disabled: busy
  }, busy ? "Saving…" : isNew ? "Add level" : "Save")));
}
class PriceTiersView extends React.Component {
  constructor(props) {
    super(props);
    /** Save the whole list; apply locally only when the server accepts it. */
    _defineProperty(this, "persist", async (next, okText) => {
      this.setState({
        busy: true,
        notice: null
      });
      try {
        await putTiers(next.map(t => ({
          ...t,
          code: String(t.code).trim().toUpperCase()
        })));
        const fresh = await getTiers().catch(() => null);
        if (this._alive) this.setState({
          busy: false,
          editing: null,
          confirmDelete: null,
          tiers: fresh || next,
          notice: okText ? {
            tone: "info",
            text: okText
          } : null
        });
        return true;
      } catch (e) {
        if (this._alive) this.setState({
          busy: false,
          notice: {
            tone: "danger",
            text: errText(e, "That change couldn't be saved. Try again.")
          }
        });
        return false;
      }
    });
    _defineProperty(this, "saveLevel", (i, t) => {
      const tiers = this.state.tiers || [];
      const next = i === "new" ? tiers.concat([{
        ...t,
        isDefault: !tiers.length
      }]) : tiers.map((x, j) => j === i ? t : x);
      this.persist(next, i === "new" ? `${t.name} added. New quotes can use it now.` : `${t.name} saved. New quotes use it now; open drafts update the next time they're saved.`);
    });
    _defineProperty(this, "makeDefault", i => {
      const tiers = this.state.tiers;
      this.persist(tiers.map((t, j) => ({
        ...t,
        isDefault: j === i
      })), `${tiers[i].name} is now the default level.`);
    });
    _defineProperty(this, "remove", i => {
      const tiers = this.state.tiers;
      const gone = tiers[i];
      let next = tiers.filter((t, j) => j !== i);
      if (gone.isDefault && next.length) next = next.map((t, j) => ({
        ...t,
        isDefault: j === 0
      }));
      this.persist(next, `${gone.name} removed.${gone.isDefault && next.length ? ` ${next[0].name} is the default now.` : ""}`);
    });
    _defineProperty(this, "saveSettings", async () => {
      this.setState({
        sbusy: true,
        notice: null
      });
      try {
        await putQuoteSettings(this.state.settings);
        if (this._alive) this.setState({
          sbusy: false,
          sdirty: false,
          notice: {
            tone: "info",
            text: "Quote settings saved."
          }
        });
      } catch (e) {
        if (this._alive) this.setState({
          sbusy: false,
          notice: {
            tone: "danger",
            text: errText(e, "The quote settings couldn't be saved.")
          }
        });
      }
    });
    _defineProperty(this, "assign", async () => {
      const {
        dealer,
        assignTier,
        tiers
      } = this.state;
      if (!dealer) return;
      this.setState({
        assignBusy: true
      });
      const r = await putDealerTier(dealer.id, assignTier || null).catch(e => ({
        _err: e
      }));
      if (!this._alive) return;
      const levelName = assignTier ? ((tiers || []).find(t => t.code === assignTier) || {}).name || assignTier : "the default level";
      if (r && r._err) this.setState({
        assignBusy: false,
        notice: {
          tone: "danger",
          text: errText(r._err, "The dealer's level couldn't be saved.")
        }
      });else if (r === null) this.setState({
        assignBusy: false,
        notice: {
          tone: "info",
          text: "Changing one dealer's level here isn't available yet. Set it in your customer file for now."
        }
      });else this.setState({
        assignBusy: false,
        dealer: {
          ...dealer,
          priceTier: assignTier
        },
        notice: {
          tone: "info",
          text: `${dealer.name} is now on ${levelName}.`
        }
      });
    });
    this.state = {
      tiers: undefined,
      settings: undefined,
      error: false,
      sdirty: false,
      busy: false,
      sbusy: false,
      notice: null,
      editing: null,
      confirmDelete: null,
      dealerQ: "",
      dealerRows: null,
      dealer: null,
      assignTier: "",
      assignBusy: false
    };
    this._alive = true;
  }
  componentDidMount() {
    getTiers().then(t => this._alive && this.setState({
      tiers: t
    })).catch(() => this._alive && this.setState({
      error: true
    }));
    getQuoteSettings().then(s => this._alive && this.setState({
      settings: s
    })).catch(() => this._alive && this.setState({
      settings: null
    }));
  }
  componentWillUnmount() {
    this._alive = false;
    clearTimeout(this._t);
  }
  searchDealers(term) {
    clearTimeout(this._t);
    if (!String(term || "").trim()) {
      this.setState({
        dealerRows: null
      });
      return;
    }
    this._t = setTimeout(() => searchDealers(term, 12).then(rows => this._alive && this.setState({
      dealerRows: rows
    })).catch(() => this._alive && this.setState({
      dealerRows: []
    })), 250);
  }
  setS(patch) {
    this.setState(s => ({
      settings: {
        ...(s.settings || DEFAULT_SETTINGS),
        ...patch
      },
      sdirty: true
    }));
  }
  renderLevels() {
    const {
      tiers,
      busy,
      editing,
      confirmDelete
    } = this.state;
    if (tiers === undefined) return /*#__PURE__*/React.createElement(Loader, null);
    if (tiers === null) return /*#__PURE__*/React.createElement("p", {
      className: "dr-dim"
    }, "Price levels aren't turned on for this workspace yet. They appear here once quotes are set up.");
    const codes = skip => tiers.filter((t, j) => j !== skip).map(t => String(t.code).toUpperCase());
    return /*#__PURE__*/React.createElement(React.Fragment, null, !tiers.length && editing !== "new" ? /*#__PURE__*/React.createElement(Empty, null, "No levels yet. Add one, for example Gold at 35% off list, and it becomes the default.") : null, tiers.map((t, i) => editing === i ? /*#__PURE__*/React.createElement(LevelForm, {
      key: `e${i}`,
      tier: t,
      busy: busy,
      codesTaken: codes(i),
      onSave: x => this.saveLevel(i, x),
      onCancel: () => this.setState({
        editing: null
      })
    }) : /*#__PURE__*/React.createElement("div", {
      className: "dr-level",
      key: t.code || i
    }, /*#__PURE__*/React.createElement("div", {
      className: "dr-level-head"
    }, /*#__PURE__*/React.createElement("b", null, t.name || t.code), t.isDefault ? /*#__PURE__*/React.createElement("span", {
      className: "dr-kind green"
    }, "Default") : null, /*#__PURE__*/React.createElement(RowMenu, {
      items: [{
        label: "Edit",
        disabled: busy,
        onClick: () => this.setState({
          editing: i,
          confirmDelete: null
        })
      }, {
        label: "Make default",
        disabled: busy || t.isDefault,
        onClick: () => this.makeDefault(i)
      }, {
        label: "Delete",
        danger: true,
        disabled: busy,
        onClick: () => this.setState({
          confirmDelete: i
        })
      }]
    })), /*#__PURE__*/React.createElement("span", {
      className: "dr-level-main"
    }, pct(t.discountPct), " off list", Object.keys(t.categoryOverrides || {}).length ? /*#__PURE__*/React.createElement(React.Fragment, null, " \xB7 ", /*#__PURE__*/React.createElement("span", {
      className: "dr-dim"
    }, overridesText(t.categoryOverrides))) : null), /*#__PURE__*/React.createElement("span", {
      className: "dr-example"
    }, "A ", usd0(EXAMPLE), " item quotes at ", usd0(EXAMPLE * (1 - (Number(t.discountPct) || 0) / 100)), ".", t.dealers != null ? ` ${Number(t.dealers).toLocaleString("en-US")} dealer${Number(t.dealers) === 1 ? "" : "s"}.` : ""), confirmDelete === i ? /*#__PURE__*/React.createElement("span", {
      className: "dr-confirm-line"
    }, "Delete ", t.name || t.code, "?", t.isDefault && tiers.length > 1 ? ` ${(tiers.find((x, j) => j !== i) || {}).name} becomes the default.` : "", /*#__PURE__*/React.createElement(Btn, {
      small: true,
      danger: true,
      disabled: busy,
      onClick: () => this.remove(i)
    }, busy ? "Deleting…" : "Delete"), /*#__PURE__*/React.createElement(Btn, {
      small: true,
      disabled: busy,
      onClick: () => this.setState({
        confirmDelete: null
      })
    }, "Cancel")) : null)), editing === "new" ? /*#__PURE__*/React.createElement(LevelForm, {
      tier: {
        code: "",
        name: "",
        discountPct: 0,
        categoryOverrides: {},
        isDefault: false
      },
      isNew: true,
      busy: busy,
      codesTaken: codes(-1),
      onSave: x => this.saveLevel("new", x),
      onCancel: () => this.setState({
        editing: null
      })
    }) : /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "dr-add",
      disabled: busy || editing !== null,
      onClick: () => this.setState({
        editing: "new",
        confirmDelete: null
      })
    }, "+ Add a level"));
  }
  renderAssign() {
    const {
      tiers,
      dealerQ,
      dealerRows,
      dealer,
      assignTier,
      assignBusy
    } = this.state;
    const def = (tiers || []).find(t => t.isDefault);
    const nameOf = code => code ? ((tiers || []).find(t => t.code === code) || {}).name || code : "Default level";
    return /*#__PURE__*/React.createElement("section", {
      className: "dr-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dr-card-head"
    }, /*#__PURE__*/React.createElement("b", null, "Give a dealer a different level"), /*#__PURE__*/React.createElement("span", null, "Dealers get ", def ? def.name : "the default level", " unless your customer file or this setting says otherwise.")), /*#__PURE__*/React.createElement("div", {
      className: "dr-assign"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dr-assign-pick"
    }, dealer ? /*#__PURE__*/React.createElement("span", {
      className: "dr-picked"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, dealer.name), dealer.customerNumber ? /*#__PURE__*/React.createElement("span", {
      className: "dr-dim"
    }, " \xB7 ", dealer.customerNumber) : null, /*#__PURE__*/React.createElement("small", null, "Now on ", nameOf(dealer.priceTier))), /*#__PURE__*/React.createElement("a", {
      onClick: () => this.setState({
        dealer: null
      })
    }, "Change")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      type: "search",
      placeholder: "Search dealers",
      value: dealerQ,
      onChange: e => {
        this.setState({
          dealerQ: e.target.value
        });
        this.searchDealers(e.target.value);
      }
    }), dealerRows && dealerQ ? /*#__PURE__*/React.createElement("span", {
      className: "dr-results"
    }, dealerRows.length ? dealerRows.map(d => /*#__PURE__*/React.createElement("button", {
      type: "button",
      key: d.id,
      onClick: () => this.setState({
        dealer: d,
        assignTier: d.priceTier || "",
        dealerRows: null
      })
    }, /*#__PURE__*/React.createElement("span", null, d.name, d.customerNumber ? /*#__PURE__*/React.createElement("span", {
      className: "dr-dim"
    }, " \xB7 ", d.customerNumber) : null), /*#__PURE__*/React.createElement("span", {
      className: "dr-dim"
    }, nameOf(d.priceTier)))) : /*#__PURE__*/React.createElement("span", {
      className: "dr-dim dr-noresult"
    }, "No dealers match.")) : null)), /*#__PURE__*/React.createElement("select", {
      value: assignTier,
      disabled: !dealer,
      onChange: e => this.setState({
        assignTier: e.target.value
      }),
      "aria-label": "Level"
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "Default level"), (tiers || []).map(t => /*#__PURE__*/React.createElement("option", {
      key: t.code,
      value: t.code
    }, t.name || t.code, " (", pct(t.discountPct), " off)"))), /*#__PURE__*/React.createElement(Btn, {
      disabled: !dealer || assignBusy,
      onClick: this.assign
    }, assignBusy ? "Saving…" : "Assign")));
  }
  renderSettings() {
    const {
      settings,
      sdirty,
      sbusy
    } = this.state;
    const st = settings || DEFAULT_SETTINGS;
    return /*#__PURE__*/React.createElement("section", {
      className: "dr-card dr-settings"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dr-card-head"
    }, /*#__PURE__*/React.createElement("b", null, "Quote settings")), settings === undefined ? /*#__PURE__*/React.createElement(Loader, null) : settings === null ? /*#__PURE__*/React.createElement("p", {
      className: "dr-dim"
    }, "Quote settings aren't available yet. Quotes stay open for 30 days, reps can go up to 10% below the level, and dealers see list prices.") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "dr-form-grid two"
    }, /*#__PURE__*/React.createElement("label", {
      className: "dr-field"
    }, "Quotes stay open for", /*#__PURE__*/React.createElement("span", {
      className: "dr-suffix"
    }, /*#__PURE__*/React.createElement("input", {
      type: "number",
      min: "1",
      value: st.validDays == null ? "" : st.validDays,
      onChange: e => this.setS({
        validDays: Number(e.target.value)
      })
    }), /*#__PURE__*/React.createElement("i", null, "days"))), /*#__PURE__*/React.createElement("label", {
      className: "dr-field"
    }, "Reps can go below the level by", /*#__PURE__*/React.createElement("span", {
      className: "dr-suffix"
    }, /*#__PURE__*/React.createElement("span", {
      className: "dr-pre"
    }, "up to"), /*#__PURE__*/React.createElement("input", {
      type: "number",
      min: "0",
      max: "100",
      value: st.maxOverridePct == null ? "" : st.maxOverridePct,
      onChange: e => this.setS({
        maxOverridePct: Number(e.target.value)
      })
    }), /*#__PURE__*/React.createElement("i", null, "% without approval"))), /*#__PURE__*/React.createElement("label", {
      className: "dr-field wide"
    }, "Freight", /*#__PURE__*/React.createElement("select", {
      value: st.freightMode,
      onChange: e => this.setS({
        freightMode: e.target.value
      })
    }, FREIGHT.map(([v, l]) => /*#__PURE__*/React.createElement("option", {
      key: v,
      value: v
    }, l)))), /*#__PURE__*/React.createElement("label", {
      className: "dr-field wide"
    }, "Terms printed on every quote", /*#__PURE__*/React.createElement("textarea", {
      rows: 3,
      value: st.terms || "",
      placeholder: "Add your terms",
      onChange: e => this.setS({
        terms: e.target.value
      })
    }))), /*#__PURE__*/React.createElement("div", {
      className: "dr-checks"
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: !!st.showListPrices,
      onChange: e => this.setS({
        showListPrices: e.target.checked
      })
    }), "Show list price and the discount on the dealer's quote"), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: !!st.requireContactEmail,
      onChange: e => this.setS({
        requireContactEmail: e.target.checked
      })
    }), "Only the dealer's own email can accept a quote"), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: !!st.statusEmailsToDealer,
      onChange: e => this.setS({
        statusEmailsToDealer: e.target.checked
      })
    }), "Email the dealer and rep when an order's status changes")), /*#__PURE__*/React.createElement("div", {
      className: "dr-form-btns start"
    }, /*#__PURE__*/React.createElement(Btn, {
      primary: true,
      disabled: sbusy || !sdirty,
      onClick: this.saveSettings
    }, sbusy ? "Saving…" : "Save"), sdirty ? /*#__PURE__*/React.createElement("span", {
      className: "dr-unsaved"
    }, "Unsaved changes") : null)));
  }
  render() {
    const {
      error,
      notice
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement(Error, null);
    if (!isAdmin()) return /*#__PURE__*/React.createElement(DataShell, {
      active: "/Data/PriceTiers",
      subtitle: "Price tiers"
    }, /*#__PURE__*/React.createElement(Empty, null, "Price levels are managed by owners and administrators."));
    return /*#__PURE__*/React.createElement(DataShell, {
      active: "/Data/PriceTiers",
      subtitle: "What dealers pay on quotes, and the settings every quote uses",
      cls: "wa-editor dr-view"
    }, notice ? /*#__PURE__*/React.createElement(Notice, {
      tone: notice.tone,
      onClose: () => this.setState({
        notice: null
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "grow"
    }, notice.text)) : null, /*#__PURE__*/React.createElement("div", {
      className: "dr-tiers"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dr-col"
    }, /*#__PURE__*/React.createElement("section", {
      className: "dr-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dr-card-head"
    }, /*#__PURE__*/React.createElement("b", null, "Dealer price levels"), /*#__PURE__*/React.createElement("span", null, "What each kind of dealer pays off list price on quotes. Options are priced the same way.")), this.renderLevels()), this.renderAssign()), this.renderSettings()));
  }
}
export default withRouter(PriceTiersView);